import { useTranslation } from "react-i18next";
import { useAddWishlistItemMutation } from "../api/wishlistApi";
import { useMutationWithFeedback } from "../../../../common/hooks/useMutationWithFeedback";

/**
 * A custom hook to encapsulate the logic for explicitly adding an item to the wishlist.
 */
export const useAddToWishlist = () => {
  const { t } = useTranslation();
  const [addWishlistItem, addResult] = useAddWishlistItemMutation();

  const { trigger: handleAddToWishlist, isLoading: isAdding } =
    useMutationWithFeedback<number[], { productId: number; parentId: number }>({
      mutation: [addWishlistItem, addResult],
      loadingMessage: t("feedback.wishlist.loading", "Updating wishlist..."),
      successMessage: t("feedback.wishlist.addedSuccess", "Added to wishlist!"),
      errorMessages: {
        default: t(
          "feedback.wishlist.toggleError",
          "Failed to update wishlist. Please try again."
        ),
      },
      // Use 'success' toast style as it's a positive primary action.
      successToastType: "success",
    });

  return {
    handleAddToWishlist,
    isAdding,
  };
};
